import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import vision2030 from "../../../img/vision-2030.png";
import "./ZatcaCompliance.css";

const points = [
  {
    title: "الربط مع هيئة الزكاة والضريبة والجمارك",
    desc: "تهيئة المنشأة ومسار Onboarding للربط مع الهيئة (ZATCA) وإرسال الفواتير الإلكترونية وفق متطلبات الالتزام.",
  },
  {
    title: "منصة فاتورة — مرحلة الربط والتكامل",
    desc: "دعم المرحلة الأولى ومرحلة الربط والتكامل (المرحلة الثانية) مع منصة فاتورة حسب إعداد المنشأة المعتمدة.",
  },
  {
    title: "ضريبة القيمة المضافة VAT",
    desc: "احتساب وإدارة ضريبة القيمة المضافة ضمن الفواتير والمستندات بما يتوافق مع متطلبات الهيئة.",
  },
  {
    title: "فاتورة ضريبية ومبسّطة",
    desc: "إصدار فواتير مبيعات ضريبية أو مبسّطة، مع الإشعارات المدينة والدائنة ضمن مسار الفوترة الإلكترونية.",
  },
  {
    title: "رمز QR والتوقيع الرقمي",
    desc: "توليد بيانات الفاتورة الإلكترونية بصيغة معتمدة تتضمن رمز الاستجابة السريعة ومتطلبات التوقيع.",
  },
  {
    title: "المتابعة وإعادة الإرسال",
    desc: "مراجعة حالة الإرسال للهيئة وإعادة إرسال الفواتير عند الحاجة مع تتبّع واضح لنتائج الربط.",
  },
];

const ZatcaCompliance = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="zatca-compliance" id="erp-zatca">
      <div className="zatca-compliance-banner">
        <div className="zatca-compliance-vision">
          <img
            src={vision2030}
            alt="رؤية المملكة العربية السعودية 2030"
            className="zatca-compliance-vision-img"
          />
        </div>
        <div className="zatca-compliance-banner-text">
          <span className="zatca-compliance-badge">ZATCA</span>
          <h2 style={{ color: darkMode ? "white" : undefined }}>
            الربط مع هيئة الزكاة والضريبة والجمارك (الزكاة والدخل)
          </h2>
          <p>
            انطلاقاً من رؤية المملكة 2030 ومتطلبات الفوترة الإلكترونية، أنظمة
            Litesoft مهيأة للربط والتكامل مع هيئة الزكاة والضريبة والجمارك ومنصة
            فاتورة — من إعداد المنشأة حتى إصدار الفاتورة وإرسالها ومتابعة حالتها،
            مع دعم ضريبة القيمة المضافة VAT.
          </p>
        </div>
      </div>

      <div className="zatca-compliance-grid">
        {points.map((point) => (
          <article className="zatca-compliance-card" key={point.title}>
            <h3 style={{ color: darkMode ? "white" : undefined }}>{point.title}</h3>
            <p>{point.desc}</p>
          </article>
        ))}
      </div>

      <div className="zatca-compliance-cta">
        <p>
          أكملنا مسارات المرحلة الثانية (الربط والتكامل) ضمن النظام. تواصل معنا
          لعرض الربط مع الهيئة ومنصة فاتورة حسب نشاط منشأتك.
        </p>
        <ScrollLink to="contact" spy={true} smooth={true} offset={-40}>
          <button type="button" className="button zatca-compliance-btn">
            اطلب عرض الربط مع الهيئة
          </button>
        </ScrollLink>
      </div>
    </section>
  );
};

export default ZatcaCompliance;
